import { render } from "./areaManage.vue?vue&type=template&id=6cdc17d6&scoped=true"
import script from "./areaManage.vue?vue&type=script&lang=js"
export * from "./areaManage.vue?vue&type=script&lang=js"

import "./areaManage.vue?vue&type=style&index=0&id=6cdc17d6&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdc17d6"]])

export default __exports__